import { render, staticRenderFns } from "./modalAñadirContacto.vue?vue&type=template&id=52963087&"
import script from "./modalAñadirContacto.vue?vue&type=script&lang=js&"
export * from "./modalAñadirContacto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports